import BaseFormPresenter from "../../../base/BaseFormPresenter";

class EmployeeFormPresenter extends BaseFormPresenter {
  constructor(
    view,
    upsertUseCase,
    getObjectUseCase,
    findObjectUseCase,
    deleteObjectUseCase
  ) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.findObjectUseCase = findObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async getExitInterview() {
    const { object } = this.view.state;
    const collection = "exit_interview";
    const id = object?.exit_interview.id;

    try {
      this.view.showLoading();

      const object = await this.getObjectUseCase.execute(collection, id);

      this.view.setState({ exitInterview: object });
      this.view.hideLoading();
    } catch (error) {
      this.view.hideLoading();
      console.error("Failed to fetch exit interview: ", error);
    }
  }
}

export default EmployeeFormPresenter;
